import { render, staticRenderFns } from "./IndividualUser.vue?vue&type=template&id=22f6565e&"
import script from "./IndividualUser.vue?vue&type=script&lang=js&"
export * from "./IndividualUser.vue?vue&type=script&lang=js&"
import style0 from "./IndividualUser.vue?vue&type=style&index=0&id=22f6565e&prod&lang=scss&"
import style1 from "./IndividualUser.vue?vue&type=style&index=1&id=22f6565e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports